<template>
  <v-dialog v-model="dialog" width="650">
    <template v-slot:activator="{}">
      <BaseButton
        :text="
          localStorage.translations.pages['setting-users']['dialog-add-buttons'][
            'priglashenie-v-proapp'
          ]
        "
        @click="openModal()"
      >
        <template v-slot:icon>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.57103 6.06429C1.49753 6.00654 1.4631 5.92022 1.4631 5.83329H1.45842V3.84937L0.606174 4.55929C0.4061 4.72612 0.291748 4.97112 0.291748 5.23129V13.125C0.291748 13.2772 0.334322 13.4178 0.402572 13.5426L5.281 9.72589L5.78032 9.33564L1.57103 6.06429Z"
              fill="#F2F2F2"
            />
            <path
              d="M13.3941 4.55929L12.5419 3.84937V5.83329H12.5372C12.5372 5.92022 12.5034 6.00654 12.4293 6.06372L8.22168 9.33389L9.30143 10.1721L13.6111 13.5181C13.6712 13.3991 13.7085 13.2673 13.7085 13.125V5.23129C13.7085 4.97114 13.5942 4.72614 13.3941 4.55929Z"
              fill="#F2F2F2"
            />
            <path
              d="M7.47705 9.4949C7.19298 9.27908 6.8068 9.27908 6.52038 9.49665L0.845703 13.937C0.944879 13.9767 1.0528 14 1.16655 14H12.8332C12.9581 14 13.0765 13.9726 13.1838 13.9253L7.47705 9.4949Z"
              fill="#F2F2F2"
            />
            <path
              d="M2.04175 0V5.691L6.26332 8.97168C6.7195 8.6806 7.28357 8.6806 7.7374 8.97168L11.9584 5.691V0H2.04175ZM8.75007 4.66668H7.29175V6.125C7.29175 6.286 7.16107 6.41668 7.00007 6.41668C6.83907 6.41668 6.7084 6.286 6.7084 6.125V4.66668H5.25007C5.08907 4.66668 4.9584 4.536 4.9584 4.375C4.9584 4.214 5.08907 4.08332 5.25007 4.08332H6.7084V2.625C6.7084 2.464 6.83907 2.33332 7.00007 2.33332C7.16107 2.33332 7.29175 2.464 7.29175 2.625V4.08332H8.75007C8.91107 4.08332 9.04175 4.214 9.04175 4.375C9.04175 4.536 8.91107 4.66668 8.75007 4.66668Z"
              fill="#F2F2F2"
            />
          </svg>
        </template>
      </BaseButton>
    </template>
    <transition :duration="150">
      <UserInviteModalForm
        v-if="dialog"
        :closeModal="closeModal"
        :subscriber="subscriber"
        :onDownloadPageData="onDownloadPageData"
      />
    </transition>
  </v-dialog>
</template>

<script>
import UserInviteModalForm from 'components/setting/users/UserInviteModalForm'
export default {
  name: 'UserInviteModal',
  props: {
    subscriber: Boolean,
    onDownloadPageData: Function,
  },
  components: { UserInviteModalForm },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
